import type { BadgeKind } from '@/components/StatusBadge';

/**
 * O que a lista, o painel e a página de conferência precisam compartilhar.
 * Fora dos arquivos de componente por causa do fast refresh do Vite.
 */
export const SITUATION_TONE: Record<string, BadgeKind> = {
  EM_CONFERENCIA: 'info',
  RECEBIDO: 'ok',
  PARCIAL: 'warn',
  COM_DIVERGENCIA: 'bad',
  CANCELADO: 'mute',
};

export const STOCK_TONE: Record<string, BadgeKind> = {
  PENDENTE: 'warn',
  INTEGRADO: 'ok',
  NAO_APLICAVEL: 'mute',
  ESTORNADO: 'bad',
};

export const DIVERGENCE_TONE: Record<string, BadgeKind> = {
  ABERTA: 'bad',
  EM_ANALISE: 'warn',
  RESOLVIDA: 'ok',
  ACEITA: 'ok',
  RECUSADA: 'mute',
};

/** Caminho da página de conferência — é para lá que "Novo recebimento" leva. */
export const conferenciaPath = (id: string): string => `/compras/recebimentos/${id}/conferir`;
/** Rota da lista, como `string`: as rotas de módulo não entram no mapa tipado do router. */
export const LISTA_RECEBIMENTOS: string = '/compras/recebimentos';

